export const SECTION_ORDER = [
  'general_information',
  'vendor_contact',
  'line_item_columns',
  'notes_and_delivery',
] as const

export type SectionType = (typeof SECTION_ORDER)[number]

const SECTION_SET: ReadonlySet<string> = new Set<string>(SECTION_ORDER)

function isSectionType(value: string): value is SectionType {
  return SECTION_SET.has(value)
}

export function toSectionType(value: string): SectionType {
  if (isSectionType(value)) return value
  return 'general_information'
}

type GridColumns = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12'

const GRID_COLUMNS_MAP: Readonly<Record<number, GridColumns>> = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: '11',
  12: '12',
}

/** Maps a column count to the F0Box `columns` prop type (max 12). */
export function toGridColumns(count: number): GridColumns {
  return GRID_COLUMNS_MAP[count] ?? '12'
}

type CustomFieldType = 'text' | 'select'

/** Returns the value typed as CustomFieldType if valid, otherwise undefined. */
export function toCustomFieldType(value: string): CustomFieldType | undefined {
  switch (value) {
    case 'text':
      return 'text'
    case 'select':
      return 'select'
    default:
      return undefined
  }
}

/** A merged field shown in the editor: either a predefined catalog field or a stored custom field. */
export type MergedField = {
  /** For predefined: "section_type.field_key". For custom: "custom:uuid" before first save, DB id after refetch. */
  key: string
  sectionType: SectionType
  fieldKey: string
  displayLabel: string
  fieldType: string
  predefined: boolean
  visible: boolean
  required: boolean
  computed: boolean
  position: number
  /** The DB id of the stored field definition, if it exists. */
  storedId: string | null
  /** The original default_value from the DB, if any. */
  defaultValue: string | null
  /** For select-type custom fields: the list of selectable options. */
  options: string[]
}
